import { useEffect } from "react";
import { scrollToSection } from "@/lib/section-nav";
import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { Hero } from "@/components/sections/Hero";
import { Services } from "@/components/sections/Services";
import { Ideas } from "@/components/sections/Ideas";
import { Leadership } from "@/components/sections/Leadership";
import { Contact } from "@/components/sections/Contact";
import { Starfield } from "@/components/visual/Starfield";
import { FlightHUD } from "@/components/visual/FlightHUD";
import { ClientOnly } from "@/components/visual/ClientOnly";

// Note: previously the Leadership and Contact sections were lazy-loaded to
// shrink the initial JS bundle. With static-site-generation now in place
// (scripts/prerender.mjs), eager imports are the right call: pre-rendering
// runs the React tree synchronously, so anything inside a Suspense boundary
// would only render its fallback into the static HTML — losing the SEO and
// LCP benefit of having the full bios + contact form in the first byte.

export default function Home() {
  // Direct `/#section` URL loads (and the prerendered build): scroll to the
  // hash target once the page renders. In-app navigation drives this from the
  // click handler instead (see scrollToSection / section-nav).
  useEffect(() => {
    scrollToSection(window.location.hash.slice(1));
  }, []);

  return (
    <div className="min-h-screen text-foreground selection:bg-primary/30">
      {/* Canvas-driven and scroll-driven decorations: client-only because they
          depend on window/Canvas/IntersectionObserver/RAF, none of which exist
          during SSG. They render nothing in the static HTML and appear after
          hydration. */}
      <ClientOnly>
        <Starfield palette="magellanic" />
        <FlightHUD />
      </ClientOnly>
      <Navbar />
      <main className="relative z-10">
        <Hero />
        <Services />
        <Ideas />
        <Leadership />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
